import * as actions from "@/modules/refunds";
import { fetchNextPageAction, responseToState } from "@/store/pagination";

export const fetchRefunds = async ({ commit, dispatch }, params) => {
  if (!params.page || params.page === 1) {
    commit("resetPagination");
  }

  const response = await actions.fetchRefunds(params);

  response.data.forEach(data => dispatch("upsertRefund", data));

  commit("updatePagination", responseToState(response, params));

  return response;
};

export const fetchNextPage = fetchNextPageAction("fetchRefunds");

export const fetchRefund = async ({ dispatch, rootGetters }, id) => {
  if (rootGetters["fetching/isFetching"](id)) {
    return await rootGetters["fetching/getRequest"](id);
  }

  const request = actions.fetchRefund(id);

  const response = await dispatch(
    "fetching/doRequest",
    { id, request },
    { root: true }
  );

  dispatch("upsertRefund", response.data);

  return response;
};

export const fetchRefundsResume = async ({ dispatch, commit, rootGetters }) => {
  const requestId = "resume";

  if (rootGetters["fetching/isFetching"](requestId)) {
    return await rootGetters["fetching/getRequest"](requestId);
  }

  const request = actions.fetchRefundsResume();

  const response = await dispatch(
    "fetching/doRequest",
    { id: requestId, request },
    { root: true }
  );

  commit("setResume", response.data);

  return response;
};

export const fetchRefundsResumeByMonth = async (
  { dispatch, commit, rootGetters },
  { year, month }
) => {
  const requestId = `resume-by-month-${year}-${month}`;

  if (!year || !month) {
    throw new Error("Year and month are required");
  }

  if (rootGetters["fetching/isFetching"](requestId)) {
    return await rootGetters["fetching/getRequest"](requestId);
  }
  const request = actions.fetchRefundsResumeByMonth(year, month);

  const response = await dispatch(
    "fetching/doRequest",
    { id: requestId, request },
    { root: true }
  );

  commit("setResumeByMonth", { year, month, data: response.data });

  return response;
};

export const fetchRefundRescueCodes = async ({ dispatch, rootGetters }, id) => {
  const requestId = `rescude-codes-${id}`;

  if (rootGetters["fetching/isFetching"](requestId)) {
    return await rootGetters["fetching/getRequest"](requestId);
  }

  const request = actions.fetchRefundRescueCodes(id);

  const response = await dispatch(
    "fetching/doRequest",
    { id: requestId, request },
    { root: true }
  );

  const rescueCodes = response.data;

  if (rescueCodes) {
    rescueCodes.forEach(rescueCode =>
      dispatch("rescueCodes/upsertRefundRescueCode", rescueCode)
    );
  }

  return response;
};

export const upsertRefund = async ({ dispatch, commit }, data) => {
  const { branch, bankAccount, rescueCodes, ...refund } = data;

  if (branch) {
    dispatch("branchs/upsertBranch", branch, { root: true });
  }

  if (bankAccount) {
    dispatch("bankAccounts/upsertBankAccount", bankAccount, { root: true });
  }

  if (rescueCodes) {
    rescueCodes.forEach(rescueCode =>
      dispatch("rescueCodes/upsertRefundRescueCode", rescueCode)
    );
  }

  commit("upsertOne", refund);
};

export default {
  fetchRefunds,
  fetchNextPage,
  fetchRefund,
  fetchRefundsResume,
  fetchRefundsResumeByMonth,
  fetchRefundRescueCodes,
  upsertRefund
};
